
export default {
  card: {
    padding: '8px',
    width: '80vw',
    maxWidth: '320px',
    height: '180px',
    textAlign: 'center',
  },
}



// WEBPACK FOOTER //
// ./src/assets/styles/components/WechatPayConfirmation.js